import { useEffect, useState } from 'react';
import { isBannedRetailer, isDisabledRetailer } from 'src/utils';
import type { CartGetData } from 'src/types';

type Props = {
  cart: CartGetData;
};

type RetailerBlockReason = 'banned' | 'disabled' | null;

export const useShowBlockedRetailerModal = ({ cart }: Props) => {
  const [reason, setReason] = useState<RetailerBlockReason>(null);

  useEffect(() => {
    if (isDisabledRetailer(cart)) {
      setReason('disabled');
    } else if (isBannedRetailer(cart)) {
      setReason('banned');
    } else {
      setReason(null);
    }
  }, [cart]);

  return { isOpen: reason !== null, reason };
};
